import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminShell from "@/components/AdminShell";
import api from "@/lib/api";

const PLANS = ["", "trial", "starter", "growth", "scale", "comp"];

export default function AdminActivity() {
  const [events, setEvents] = useState([]);
  const [type, setType] = useState("");
  const [plan, setPlan] = useState("");
  const [live, setLive] = useState(false);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const q = [];
      if (type) q.push(`event_type=${encodeURIComponent(type)}`);
      if (plan) q.push(`plan=${encodeURIComponent(plan)}`);
      const r = await api.get(`/admin/activity?${q.join("&")}&limit=200`);
      setEvents(r.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Admin · Activity";
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, plan]);

  useEffect(() => {
    if (!live) return;
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [live, type, plan]);

  const knownTypes = Array.from(new Set(events.map((e) => e.event_type))).sort();

  return (
    <AdminShell>
      <div className="mb-6 flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="mono text-[10px] uppercase tracking-[0.22em] text-zinc-500">
            Activity
          </div>
          <h1 className="display mt-1 text-3xl font-black tracking-tight">
            Platform pulse
          </h1>
        </div>
        <div className="flex items-center gap-2">
          <select
            value={type}
            onChange={(e) => setType(e.target.value)}
            data-testid="activity-filter-type"
            className="bg-zinc-950 border border-zinc-800 rounded-[3px] px-2 py-1 text-xs"
          >
            <option value="">All event types</option>
            {knownTypes.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
          <select
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
            data-testid="activity-filter-plan"
            className="bg-zinc-950 border border-zinc-800 rounded-[3px] px-2 py-1 text-xs"
          >
            <option value="">All plans</option>
            {PLANS.slice(1).map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
          <label className="flex items-center gap-1.5 text-xs bg-zinc-900 border border-zinc-800 rounded-[3px] px-2 py-1 cursor-pointer">
            <input
              type="checkbox"
              checked={live}
              onChange={(e) => setLive(e.target.checked)}
              data-testid="activity-live-toggle"
            />
            Live
          </label>
        </div>
      </div>

      <div className="bg-zinc-900/60 border border-zinc-800 rounded-[4px] divide-y divide-zinc-800">
        {loading && (
          <div className="p-3 text-xs text-zinc-500">Loading…</div>
        )}
        {!loading && events.length === 0 && (
          <div className="p-3 text-xs text-zinc-500">No activity yet.</div>
        )}
        {events.map((e) => (
          <div
            key={e.activity_id}
            className="p-2 text-xs flex items-center gap-3"
            data-testid={`activity-row-${e.activity_id}`}
          >
            <span className="mono text-[10px] uppercase tracking-[0.14em] text-zinc-400 w-32 shrink-0">
              {e.event_type}
            </span>
            <span className="flex-1 truncate">{e.description}</span>
            {e.user_email && (
              <Link
                to={`/admin/users/${e.user_id}`}
                className="mono text-[10px] text-zinc-400 hover:text-white"
              >
                {e.user_email}
              </Link>
            )}
            {e.user_plan && (
              <span className="mono text-[10px] uppercase tracking-[0.14em] px-1 border border-zinc-700 rounded-sm">
                {e.user_plan}
              </span>
            )}
            <span className="mono text-[10px] text-zinc-500 shrink-0 w-32 text-right">
              {new Date(e.created_at).toLocaleString(undefined, {
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })}
            </span>
          </div>
        ))}
      </div>
    </AdminShell>
  );
}
